// Admin Imports
import MainDashboard from "views/admin/default";
import EditStaff from "views/admin/staff/edit";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdArticle,
  MdAttachMoney,
  MdHome,
  MdLock,
  MdPerson,
  MdSupervisorAccount,
  MdInsertDriveFile,
  MdAccountBalanceWallet,
  MdAddTask,
  MdDescription,
  MdShoppingCart,
  MdFamilyRestroom,
} from "react-icons/md";
import Article from "views/admin/article";
import CreateArticle from "views/admin/article/create";
import UpdateArticle from "views/admin/article/update";
import Staff from "views/admin/staff";
import AddToStaff from "views/admin/staff/create";
import Subscription from "views/admin/subscription";
import CancelSubscription from "views/admin/subscription/cancel";
import SubscriptionHistory from "views/admin/subscription/history";
import SuccessSubscription from "views/admin/subscription/success";
import ForgetPassword from "views/auth/ForgetPassword";
import SetPassword from "views/auth/SetPassword";
import Devis from "views/admin/devis";
import CreateDevis from "views/admin/devis/create";
import UpdateDevis from "views/admin/devis/update";
import Invoice from "views/admin/invoice";
import CreateInvoice from "views/admin/invoice/create";
import UpdateInvoice from "views/admin/invoice/update";
import Clients from "views/admin/client";
import CreateClient from "views/admin/client/create";
import UpdateClient from "views/admin/client/update";
import Commande from "views/admin/commande";
import UpdateCommande from "views/admin/commande/update";
import { Cerfat } from "views/admin/cerfa";
import CreateCerfa from "views/admin/cerfa/create";
import UpdateCerfa from "views/admin/cerfa/update";
import BonDeCommande from "views/admin/bon-commande";
import CreateBonDeCommande from "views/admin/bon-commande/create";
import UpdateBonDeCommande from "views/admin/bon-commande/update";
import Families from "views/admin/family";
import CreateFamily from "views/admin/family/create";
import UpdateFamily from "views/admin/family/update";

const routes = [
  {
    name: "Tableau de bord",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-[18px] w-[18px]" />,
    component: <MainDashboard />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <SignIn />,
  },
  {
    name: "Personnel",
    layout: "/admin",
    path: "staff",
    icon: <MdSupervisorAccount className="h-[18px] w-[18px]" />,
    component: <Staff />,
    show: true,
    admin: true,
  },
  {
    name: "Clients",
    layout: "/admin",
    path: "client",
    icon: <MdPerson className="h-[18px] w-[18px]" />,
    component: <Clients />,
    show: true,
  },
  {
    name: "Create Client",
    layout: "/admin",
    path: "client/create",
    icon: <MdPerson className="h-[18px] w-[18px]" />,
    component: <CreateClient />,
  },
  {
    name: "Update Client",
    layout: "/admin",
    path: "client/:id",
    icon: <MdPerson className="h-[18px] w-[18px]" />,
    component: <UpdateClient />,
  },
  {
    name: "Familles",
    layout: "/admin",
    path: "family",
    icon: <MdFamilyRestroom className="h-[18px] w-[18px]" />,
    component: <Families />,
    show: true,
  },
  {
    name: "Create Family",
    layout: "/admin",
    path: "family/create",
    icon: <MdFamilyRestroom className="h-[18px] w-[18px]" />,
    component: <CreateFamily />,
  },
  {
    name: "Update Family",
    layout: "/admin",
    path: "family/:id",
    icon: <MdFamilyRestroom className="h-[18px] w-[18px]" />,
    component: <UpdateFamily />,
  },
  {
    name: "Article",
    layout: "/admin",
    path: "article",
    icon: <MdArticle className="h-[18px] w-[18px]" />,
    component: <Article />,
    show: true,
  },
  {
    name: "Create Article",
    layout: "/admin",
    path: "article/create",
    icon: <MdArticle className="h-[18px] w-[18px]" />,
    component: <CreateArticle />,
  },
  {
    name: "Update Article",
    layout: "/admin",
    path: "article/:id",
    icon: <MdArticle className="h-[18px] w-[18px]" />,
    component: <UpdateArticle />,
  },
  {
    name: "Devis",
    layout: "/admin",
    path: "devis",
    icon: <MdInsertDriveFile className="h-[18px] w-[18px]" />,
    component: <Devis />,
    show: true,
  },
  {
    name: "Create Devis",
    layout: "/admin",
    path: "devis/create",
    icon: <MdInsertDriveFile className="h-[18px] w-[18px]" />,
    component: <CreateDevis />,
  },
  {
    name: "Update Devis",
    layout: "/admin",
    path: "devis/:id",
    icon: <MdInsertDriveFile className="h-[18px] w-[18px]" />,
    component: <UpdateDevis />,
  },
  {
    name: "Commande",
    layout: "/admin",
    path: "commande",
    icon: <MdAddTask className="h-[18px] w-[18px]" />,
    component: <Commande />,
    show: true,
  },
  {
    name: "Update Commande",
    layout: "/admin",
    path: "commande/:id",
    icon: <MdAddTask className="h-[18px] w-[18px]" />,
    component: <UpdateCommande />,
  },
  {
    name: "Facture",
    layout: "/admin",
    path: "invoice",
    icon: <MdAccountBalanceWallet className="h-[18px] w-[18px]" />,
    component: <Invoice />,
    show: true,
  },
  {
    name: "Create Facture",
    layout: "/admin",
    path: "invoice/create",
    icon: <MdAccountBalanceWallet className="h-[18px] w-[18px]" />,
    component: <CreateInvoice />,
  },
  {
    name: "Update Facture",
    layout: "/admin",
    path: "invoice/:id",
    icon: <MdAccountBalanceWallet className="h-[18px] w-[18px]" />,
    component: <UpdateInvoice />,
  },
  {
    name: "Abonnements",
    layout: "/admin",
    path: "subscriptions",
    icon: <MdAttachMoney className="h-[18px] w-[18px]" />,
    component: <SubscriptionHistory />,
    show: true,
    admin: true,
  },
  {
    name: "Ajouter un membre au staff",
    layout: "/admin",
    path: "staff/create",
    icon: <MdHome className="h-[18px] w-[18px]" />,
    component: <AddToStaff />,
    admin: true,
  },
  {
    name: "Modifier un membre du staff",
    layout: "/admin",
    path: "staff/edit/:userId",
    icon: <MdHome className="h-[18px] w-[18px]" />,
    component: <EditStaff />,
    admin: true,
  },
  {
    name: "Définir un mot de passe",
    layout: "/auth",
    path: "set-password",
    icon: <MdHome className="h-[18px] w-[18px]" />,
    component: <SetPassword />,
  },
  {
    name: "Mots de passe oublié?",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <ForgetPassword />,
  },
  {
    name: "Abonnement",
    layout: "/auth",
    path: "subscription",
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <Subscription />,
  },
  {
    name: "Abonnement",
    layout: "/auth",
    path: "subscription/success",
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <SuccessSubscription />,
  },
  {
    name: "Abonnement",
    layout: "/auth",
    path: "subscription/cancel",
    icon: <MdLock className="h-[18px] w-[18px]" />,
    component: <CancelSubscription />,
  },
  {
    name: "Cerfa",
    layout: "/admin",
    path: "cerfa",
    icon: <MdDescription className="h-[18px] w-[18px]" />,
    component: <Cerfat />,
    show: true,
  },
  {
    name: "Créer CERFA",
    layout: "/admin",
    path: "cerfa/create",
    icon: <MdDescription className="h-[18px] w-[18px]" />,
    component: <CreateCerfa />,
  },
  {
    name: "Modifier CERFA",
    layout: "/admin",
    path: "cerfa/:id",
    icon: <MdDescription className="h-[18px] w-[18px]" />,
    component: <UpdateCerfa />,
  },
  {
    name: "Bon de commande",
    layout: "/admin",
    path: "bon-commande",
    show: true,
    icon: <MdShoppingCart className="h-[18px] w-[18px]" />, // Changed icon
    component: <BonDeCommande />,
  },
  {
    name: "Create Bon de commande",
    layout: "/admin",
    path: "bon-commande/create",
    icon: <MdShoppingCart className="h-[18px] w-[18px]" />, // Changed icon
    component: <CreateBonDeCommande />,
  },
  {
    name: "Update Bon de commande",
    layout: "/admin",
    path: "bon-commande/:id",
    icon: <MdShoppingCart className="h-[18px] w-[18px]" />, // Changed icon
    component: <UpdateBonDeCommande />,
  },
];
export default routes;
